<template>
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.0417 6.375L10.0869 9.30713C9.69545 9.89435 8.81564 9.83958 8.50002 9.20833V9.20833C8.1844 8.57709 7.30459 8.52231 6.91311 9.10954L4.95835 12.0417"
      stroke="#666666"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      class="stroke"
    />
    <rect
      x="2.125"
      y="2.125"
      width="12.75"
      height="12.75"
      rx="2"
      stroke="#666666"
      stroke-width="1.5"
      class="stroke"
    />
  </svg>
</template>
<style lang="scss" scoped>
svg {
  max-width: 20px;
  max-height: 20px;
}
.v-list-item--active svg .fill {
  fill: #df252a;
}
.v-list-item--active svg .stroke {
  stroke: #df252a;
}
</style>
